webpackJsonp([13],{

/***/ 1107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMerge_vue__ = __webpack_require__(1256);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d68c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMerge_vue__ = __webpack_require__(1376);
function injectStyle (ssrContext) {
  __webpack_require__(1371)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9d68c1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMerge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d68c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMerge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FTextarea',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    rows: {
      default: 3
    },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"error":_vm.error}},[_c('textarea',{class:['form-control', _vm.error && 'is-invalid'],attrs:{"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Horses_HorseMergeProfile__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__composables_horses_useHorseMerge__ = __webpack_require__(1375);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var COUNT_LABELS = {
  nominations: 'Nominations',
  draws: 'Runs',
  results: 'Results',
  prizes: 'Prizes',
  horse_points: 'Point records',
  horse_states: 'Status history',
  rookies: 'Rookie nominations',
  rookie_memberships: 'Rookie memberships',
  owners: 'Owners',
  riders: 'Riders',
  awards: 'Awards',
  sire_eligibilities: 'Sire eligibilities',
  offspring: 'Offspring'
};

function extractError(err) {
  var data = err.response != null ? err.response.data : null;
  return data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'HorseMerge',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FTextarea__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FCheckbox__["a" /* default */],
    HorseMergeProfile: __WEBPACK_IMPORTED_MODULE_9__components_Horses_HorseMergeProfile__["a" /* default */]
  },
  props: {
    sourceHorseId: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var horseMerge = Object(__WEBPACK_IMPORTED_MODULE_11__composables_horses_useHorseMerge__["a" /* default */])(proxy);
    var targetHorseId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var selectedTarget = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var reason = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var confirmed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var error = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var showConfirmModal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var targetOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var selected = horseMerge.preview.value != null ? horseMerge.preview.value.target : selectedTarget.value;
      if (!selected) return horseMerge.searchResults.value;
      var hasSelected = horseMerge.searchResults.value.some(function (horse) {
        return horse.id === selected.id;
      });
      return hasSelected ? horseMerge.searchResults.value : [selected].concat(_toConsumableArray(horseMerge.searchResults.value));
    });
    var transferCounts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!horseMerge.preview.value) return [];
      return Object.keys(COUNT_LABELS).map(function (key) {
        return {
          key: key,
          label: COUNT_LABELS[key],
          value: horseMerge.preview.value.transfer_counts[key]
        };
      });
    });
    var canSubmit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return horseMerge.preview.value != null && horseMerge.preview.value.can_merge && reason.value.trim().length > 0 && confirmed.value;
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(targetHorseId, function () {
      error.value = null;
      reason.value = '';
      confirmed.value = false;
      showConfirmModal.value = false;
      horseMerge.clearPreview();
    });

    function handleSearch(query) {
      horseMerge.search(query, props.sourceHorseId);
    }

    function handleTargetSelect(target) {
      selectedTarget.value = target;
    }

    function handlePreview() {
      return _handlePreview.apply(this, arguments);
    }

    function _handlePreview() {
      _handlePreview = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (targetHorseId.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                error.value = null;
                _context.prev = 3;
                _context.next = 6;
                return horseMerge.loadPreview(props.sourceHorseId, targetHorseId.value);

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                error.value = extractError(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 8]]);
      }));
      return _handlePreview.apply(this, arguments);
    }

    function handleMerge() {
      if (!canSubmit.value) return;
      error.value = null;
      showConfirmModal.value = true;
    }

    function confirmMerge() {
      return _confirmMerge.apply(this, arguments);
    }

    function _confirmMerge() {
      _confirmMerge = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!canSubmit.value || horseMerge.merging.value)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                error.value = null;
                _context2.prev = 3;
                _context2.next = 6;
                return horseMerge.merge(props.sourceHorseId, targetHorseId.value, horseMerge.preview.value.preview_token, reason.value.trim());

              case 6:
                response = _context2.sent;
                showConfirmModal.value = false;
                proxy.$router.push({
                  name: 'Admin Horse Profile',
                  params: {
                    slug: response.data.target_horse_id
                  }
                }, function () {
                  proxy.$nextTick(function () {
                    return __WEBPACK_IMPORTED_MODULE_10__store_EventBus__["a" /* default */].$emit('show-success', response.message);
                  });
                });
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                showConfirmModal.value = false;
                error.value = extractError(_context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11]]);
      }));
      return _confirmMerge.apply(this, arguments);
    }

    function closeConfirmModal() {
      if (!horseMerge.merging.value) showConfirmModal.value = false;
    }

    function goBack() {
      proxy.$router.push({
        name: 'Admin Horse Profile',
        params: {
          slug: props.sourceHorseId
        }
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      horseMerge.loadInitialOptions(props.sourceHorseId).catch(function () {});
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      horseMerge.reset();
    });
    return {
      targetHorseId: targetHorseId,
      targetOptions: targetOptions,
      reason: reason,
      confirmed: confirmed,
      error: error,
      showConfirmModal: showConfirmModal,
      transferCounts: transferCounts,
      canSubmit: canSubmit,
      preview: horseMerge.preview,
      searchLoading: horseMerge.searchLoading,
      previewLoading: horseMerge.previewLoading,
      merging: horseMerge.merging,
      handleSearch: handleSearch,
      handleTargetSelect: handleTargetSelect,
      handlePreview: handlePreview,
      handleMerge: handleMerge,
      confirmMerge: confirmMerge,
      closeConfirmModal: closeConfirmModal,
      goBack: goBack
    };
  }
}));

/***/ }),

/***/ 1257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseMergeProfile',
  props: {
    horse: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      fields: [{
        key: 'id',
        label: 'ID'
      }, {
        key: 'name',
        label: 'Name'
      }, {
        key: 'owner',
        label: 'Owner'
      }, {
        key: 'gender',
        label: 'Sex'
      }, {
        key: 'dob',
        label: 'Date of birth'
      }, {
        key: 'registration_date',
        label: 'Registered'
      }, {
        key: 'ashs_number',
        label: 'ASHS#'
      }, {
        key: 'aqhs_number',
        label: 'AQHA#'
      }, {
        key: 'sire_id',
        label: 'Sire ID'
      }, {
        key: 'dam_id',
        label: 'Dam ID'
      }, {
        key: 'historic_point_ach',
        label: 'Historic ACH'
      }, {
        key: 'historic_point_rom',
        label: 'Historic ROM'
      }]
    };
  },
  methods: {
    displayValue: function displayValue(key) {
      var value = this.horse[key];
      return value !== null && value !== '' ? value : '—';
    }
  }
});

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("9153deac", content, true, {});

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".merge-horse__card[data-v-f9d68c1e]{border:2px solid transparent}.merge-horse__card--remove[data-v-f9d68c1e]{border-color:var(--danger)}.merge-horse__card--keep[data-v-f9d68c1e]{border-color:var(--success)}.merge-horse__counts[data-v-f9d68c1e]{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:.75rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Horses/Merge/HorseMerge.vue"],"names":[],"mappings":"AACA,oCACE,4BAA8B,CAC/B,AACD,4CACE,0BAA4B,CAC7B,AACD,0CACE,2BAA6B,CAC9B,AACD,sCACE,aAAc,AACd,yDAA4D,AAC5D,UAAa,CACd","file":"HorseMerge.vue","sourcesContent":["\n.merge-horse__card[data-v-f9d68c1e] {\n  border: 2px solid transparent;\n}\n.merge-horse__card--remove[data-v-f9d68c1e] {\n  border-color: var(--danger);\n}\n.merge-horse__card--keep[data-v-f9d68c1e] {\n  border-color: var(--success);\n}\n.merge-horse__counts[data-v-f9d68c1e] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.75rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMergeProfile_vue__ = __webpack_require__(1257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669fff35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMergeProfile_vue__ = __webpack_require__(1374);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMergeProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669fff35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMergeProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"row mb-0"},[_vm._l((_vm.fields),function(field){return [_c('dt',{key:((field.key) + "-label"),staticClass:"col-5"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('dd',{key:field.key,staticClass:"col-7"},[_vm._v(_vm._s(_vm.displayValue(field.key)))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useHorseMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useHorseMerge(proxy) {
  var store = proxy.$store;
  var searchResults = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return store.getters['horseMerge/searchResults'];
  });
  var searchLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return store.getters['horseMerge/searchLoading'];
  });
  var preview = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return store.getters['horseMerge/preview'];
  });
  var previewLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return store.getters['horseMerge/previewLoading'];
  });
  var merging = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return store.getters['horseMerge/merging'];
  });
  var searchTimer = null;

  function search(query, sourceHorseId) {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      store.dispatch('horseMerge/search', {
        query: query,
        sourceHorseId: sourceHorseId
      }).catch(function () {});
    }, 250);
  }

  function loadInitialOptions(sourceHorseId) {
    return store.dispatch('horseMerge/search', {
      query: '',
      sourceHorseId: sourceHorseId
    });
  }

  function loadPreview(sourceHorseId, targetHorseId) {
    return store.dispatch('horseMerge/preview', {
      source_horse_id: Number(sourceHorseId),
      target_horse_id: Number(targetHorseId)
    });
  }

  function merge(sourceHorseId, targetHorseId, previewToken, reason) {
    return store.dispatch('horseMerge/merge', {
      source_horse_id: Number(sourceHorseId),
      target_horse_id: Number(targetHorseId),
      preview_token: previewToken,
      reason: reason
    });
  }

  function clearPreview() {
    return store.dispatch('horseMerge/clearPreview');
  }

  function reset() {
    clearTimeout(searchTimer);
    return store.dispatch('horseMerge/reset');
  }

  return {
    searchResults: searchResults,
    searchLoading: searchLoading,
    preview: preview,
    previewLoading: previewLoading,
    merging: merging,
    search: search,
    loadInitialOptions: loadInitialOptions,
    loadPreview: loadPreview,
    merge: merge,
    clearPreview: clearPreview,
    reset: reset
  };
}

/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-start mb-3"},[_c('page-heading',[_vm._v("Merge Horse")]),_vm._v(" "),_c('app-button',{attrs:{"variant":"outline-primary","block":false},on:{"click":_vm.goBack}},[_vm._v("Back to Horse")])],1),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('strong',[_vm._v("This operation cannot be undone.")]),_vm._v("\n      Horse #"+_vm._s(_vm.sourceHorseId)+" will be removed. Its runs, results and related records will be moved to the horse selected below.\n    ")]),_vm._v(" "),_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handlePreview($event)}}},[_c('form-alert',{attrs:{"message":_vm.error}}),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half"},[_c('f-search-select',{attrs:{"id":"merge-target-horse","label":"Horse to keep","options":_vm.targetOptions,"loading":_vm.searchLoading,"required":true,"show-reset":false,"placeholder":"Search by horse name...","hint":"The selected horse's profile details will be kept."},on:{"search-change":_vm.handleSearch,"select":_vm.handleTargetSelect},model:{value:(_vm.targetHorseId),callback:function ($$v) {_vm.targetHorseId=$$v},expression:"targetHorseId"}})],1)]),_vm._v(" "),_c('app-button',{staticClass:"mt-2",attrs:{"block":false,"type":"submit","loading":_vm.previewLoading,"disabled":!_vm.targetHorseId}},[_vm._v("Review Merge")])],1),_vm._v(" "),(_vm.preview)?[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12 col-lg-6 mb-3 mb-lg-0"},[_c('section',{staticClass:"merge-horse__card merge-horse__card--remove rounded p-3 h-100"},[_c('h2',{staticClass:"h4"},[_vm._v("Horse to remove")]),_vm._v(" "),_c('horse-merge-profile',{attrs:{"horse":_vm.preview.source}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('section',{staticClass:"merge-horse__card merge-horse__card--keep rounded p-3 h-100"},[_c('h2',{staticClass:"h4"},[_vm._v("Horse to keep")]),_vm._v(" "),_c('horse-merge-profile',{attrs:{"horse":_vm.preview.target}})],1)])]),_vm._v(" "),_c('section',{staticClass:"mt-4"},[_c('h2',{staticClass:"h4"},[_vm._v("Records to transfer")]),_vm._v(" "),_c('div',{staticClass:"merge-horse__counts"},_vm._l((_vm.transferCounts),function(item){return _c('div',{key:item.key,staticClass:"bg-lighter rounded p-3"},[_c('span',{staticClass:"text-muted d-block"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('strong',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(item.value))])])}),0)]),_vm._v(" "),(_vm.preview.warnings.length)?_c('div',{staticClass:"alert alert-warning mt-4 mb-0"},[_c('strong',[_vm._v("Review these differences:")]),_vm._v(" "),_c('ul',{staticClass:"mb-0 mt-2"},_vm._l((_vm.preview.warnings),function(warning){return _c('li',{key:warning},[_vm._v(_vm._s(warning))])}),0)]):_vm._e(),_vm._v(" "),(_vm.preview.blockers.length)?_c('div',{staticClass:"alert alert-danger mt-4 mb-0"},[_c('strong',[_vm._v("This merge is blocked:")]),_vm._v(" "),_c('ul',{staticClass:"mb-0 mt-2"},_vm._l((_vm.preview.blockers),function(blocker){return _c('li',{key:blocker},[_vm._v(_vm._s(blocker))])}),0)]):_vm._e(),_vm._v(" "),(_vm.preview.can_merge)?_c('form',{staticClass:"mt-4",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleMerge($event)}}},[_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__full"},[_c('f-textarea',{attrs:{"id":"merge-reason","label":"Reason for merge","rows":3,"required":true,"placeholder":"Explain why these records are duplicates..."},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__full"},[_c('f-checkbox',{attrs:{"id":"confirm-horse-merge","label":"I have reviewed both horses and understand that this operation cannot be undone.","required":true},model:{value:(_vm.confirmed),callback:function ($$v) {_vm.confirmed=$$v},expression:"confirmed"}})],1)]),_vm._v(" "),_c('app-button',{attrs:{"variant":"primary","block":false,"type":"submit","loading":_vm.merging,"disabled":!_vm.canSubmit}},[_vm._v("Merge Horses")])],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.showConfirmModal && _vm.preview)?_c('modal',{attrs:{"size":"lg"},on:{"close":_vm.closeConfirmModal}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Please confirm the horses to be merged")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_c('strong',[_vm._v("This operation cannot be undone.")]),_vm._v("\n          Horse #"+_vm._s(_vm.preview.source.id)+" will be removed and its related records will be transferred to horse #"+_vm._s(_vm.preview.target.id)+".\n        ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0"},[_c('h4',[_vm._v("Horse To Keep")]),_vm._v(" "),_c('div',{staticClass:"bg-lighter rounded p-3"},[_c('horse-merge-profile',{attrs:{"horse":_vm.preview.target}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h4',[_vm._v("Horse To Remove")]),_vm._v(" "),_c('div',{staticClass:"bg-lighter rounded p-3"},[_c('horse-merge-profile',{attrs:{"horse":_vm.preview.source}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"footer"},slot:"footer"},[_c('app-button',{attrs:{"block":false,"loading":_vm.merging,"disabled":_vm.merging},on:{"click":_vm.confirmMerge}},[_vm._v("Confirm")]),_vm._v(" "),_c('app-button',{staticClass:"ml-2",attrs:{"variant":"outline-primary","block":false,"disabled":_vm.merging},on:{"click":_vm.closeConfirmModal}},[_vm._v("Cancel")])],1)]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.fdfb6320bc14fd7909e8.js